/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

// 校验名称 只可输入中英文与字母与数字
export const validateUserName = (rule, value, callback) => {
  const pattern = new RegExp(
    /^[\u4e00-\u9fa5-_a-zA-Z0-9\s*]+$/
  );
  if (!value) {
    callback(new Error('名称不能为空'));
  } else if (!pattern.test(value)) {
    callback(new Error('不能包含特殊字符'));
  } else {
    callback();
  }
};
// 校验名称 只可输入中英文与字母与数字
export const validateOrganizaUserName = (rule, value, callback) => {
  const pattern = new RegExp(
    /^[-_a-zA-Z0-9\s*]+$/
  );
  if (!value) {
    callback(new Error('名称不能为空'));
  } else if (!pattern.test(value)) {
    callback(new Error('不能包含特殊字符'));
  } else {
    callback();
  }
};
// 校验名称 只可输入中英文与字母与数字
export const validatePassword = (rule, value, callback) => {
  const pattern = new RegExp(
    /^(?=.*?[0-9])(?=.*?[a-zA-Z])[0-9a-zA-Z]{6,10}$/
  );
  if (!value) {
    callback(new Error('密码不能为空'));
  } else if (!pattern.test(value)) {
    callback(new Error(' 请填写6-10位字母+数字组合的字符'));
  } else {
    callback();
  }
};

// 校验数字
export const validateNumber = (rule, value, callback) => {
  const pattern = new RegExp(/(^[1-9]\d*$)/);
  if (!pattern.test(value)) {
    callback(new Error('请输入正确的数字'));
    return false;
  } else {
    callback();
  }
};

// 校验手机号码
export const validatePhone = (rule, value, callback) => {
  const pattern = new RegExp(/^[1]([3-9])[0-9]{9}$/);
  if (!value) {
    callback(new Error('手机号不能为空'));
    return false;
  } else if (!pattern.test(value)) {
    callback(new Error('请输入正确的手机号码'));
    return false;
  } else {
    callback();
  }
};
